export function networkEmblemUrl(chainId: string, isTestNet: boolean): string {
  const fileName = `${chainId.toLowerCase()}-${isTestNet ? "testnet" : "mainnet"}.svg`;
  return `https://static.alchemyapi.io/images/emblems/${fileName}`;
}
